import { D } from '@mobily/ts-belt';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';
import { global_triple_block } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { TripleBlockProps } from './TripleBlock';
export const tripleBlockSchema = global_triple_block.transform<TripleBlockProps>(data => ({
  blocks: data.block.map<TripleBlockProps['blocks'][number]>(block => {
    return {
      title: block.title,
      illustration: block.illustration,
      description: block.description,
      image: !D.isEmpty(block.image.src) ? getCloudinaryImageFields({
        alt: block.image.alt,
        cloudinaryField: block.image.src,
        shouldUseV2: true
      }) : null
    };
  }),
  blockSize: data.block_size,
  title: data.title
}));